<template>
   <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('user.password_change')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="password">

                <loading slot="waiting"/>

                <form @submit.prevent="validate_password">

                    <div class="form-group">

                        <label for="password">{{ $t('simple.password') }}</label>

                        <input
                            class="form-control"
                            type="password"
                            id="password"
                            ref="password"
                            name="password"
                            v-validate="'required|min:8'"
                            v-model="password"
                        >

                        <small v-show="errors.has('password')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('password') }}</small>

                    </div>

                    <div class="form-group">

                        <label for="password_confirmation">{{ $t('user.password_confirmation') }}</label>

                        <input
                            class="form-control"
                            type="password"
                            id="password_confirmation"
                            name="password_confirmation"
                            v-validate="'required|confirmed:password'"
                            v-model="password_confirmation"
                        >

                        <small v-show="errors.has('password_confirmation')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('password_confirmation') }}</small>

                    </div>

                </form>

            </v-wait>

        </div>

        <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                                     title:!user_permissions.includes('update-users')? $t('permission.permission_denied', { permission: 'update-users' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button @click="validate_password()" variant="primary" :class="!user_permissions.includes('update-users') ? 'cursor-not-allowed' : ''"
                        :disabled="!user_permissions.includes('update-users')">{{ $t('simple.save') }}</b-button>
            </div>
        </div>


        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('User Password Change Modal mounted');
        },
        
        destroyed() {
            // Component destroyed
            console.log('User Password Change Modal destroyed.');
        },

        data: function() {
            return  {

                password_api: '/api/v1/user/password/',

                password: '',
                password_confirmation: '',
            }
        },

        methods: {
            
            password_change: async function(){

                // Loading start
                this.$wait.start('password');

                // Post request
                await axios.put(this.password_api + this.id , {
                    password: this.password,
                  })
                  .then((response) => {

                    // Show success
                    Vue.toasted.success(this.$t('simple.success_info'));

                    // Close modal
                    this.$close(true);

                   // Loading end
                    this.$wait.end('password');

                  })
                  .catch((error) => {
                    // Show error
                    if (error.response && error.response.status === 403) {
                      Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'update-users'}));
                    } else {
                      Vue.toasted.error(this.$t('simple.error_info'));
                    }
                    // Log to console
                    //console.log(error);

                    // Close modal
                    //this.$close(true);

                    // Loading end
                    this.$wait.end('password');

                  });

            },

            validate_password: async function() {
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.password_change();
                    }
                });
            },
        },
      computed: {
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        }),
      }
    }
</script>
